module.exports = __webpack_public_path__ + "img/gift_uk.ada1aec4.jpg";